import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Rows from '../components/AssetRow';
import Footer from "../components/Footer";
import Greet from '../components/Greet';
import axios from "axios";

function Home() {
  const loggedIn = sessionStorage.getItem("LoggedIn");
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {}, []);

  return (
    <div>
      <Navbar onSearch={setSearchQuery} showSearch={true} />
      <Rows searchQuery={searchQuery} />
      <Footer />
    </div>
  );
}

export default Home;
